import { put, call } from 'redux-saga/effects'
import TicketsActions from 'store/models/tickets'
import { submitToApi } from 'awsApi'
import { URL } from './endpoints'

export function* getTickets() {
    try {
        const { supplierId } = JSON.parse(localStorage.getItem('supplier'))

        const { payload } = yield call(() =>
            submitToApi({
                path: URL.EMAIL_SUPPORT.V2_EMAILSUPPORT_USER_GETTRANSACTIONS,
                query: { supplierId },
                url: URL.EMAIL_SUPPORT.BASE,
                withoutUserId: true,
            })
        )
        yield put(TicketsActions.getTicketsSuccess(payload.data))
    } catch (error) {
        yield put(TicketsActions.getTicketsFailure(error))
    }
}

export function* closeTicket({ ticketId, callback }) {
    const supplier = JSON.parse(localStorage.getItem('supplier'))
    try {
        const { message } = yield call(() =>
            submitToApi({
                body: { ticketId, supplierName: supplier.companyName },
                method: 'PUT',
                path: URL.EMAIL_SUPPORT.V2_EMAILSUPPORT_USER_CLOSETICKET,
                query: { from: 'supplier' },
                url: URL.EMAIL_SUPPORT.BASE,
            })
        )
        yield put(TicketsActions.closeTicketSuccess())
        callback(message, 'success')
    } catch (error) {
        yield put(TicketsActions.closeTicketFailure())
        callback(error, 'error')
    }
}

export function* getThread({ ticketId }) {
    try {
        const { payload } = yield call(() =>
            submitToApi({
                path: URL.EMAIL_SUPPORT.V2_EMAILSUPPORT_USER_GETTRANSACTIONS,
                query: { ticketId, emailThreads: 'supplier' },
                url: URL.EMAIL_SUPPORT.BASE,
                withoutUserId: true,
            })
        )
        yield put(TicketsActions.getThreadSuccess(ticketId, payload.data))
    } catch (error) {
        yield put(TicketsActions.getThreadFailure(error))
    }
}
